<style lang="less" scoped>
  @import "../../../style/theme.less";

  p.small {
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-bottom: 0;
  }

  .divider {
    background-color: fade(@primary-color, 40%);
  }

  h1 {
    font-family: "Kaushan Script", cursive;
    font-weight: 400;
    font-size: 28px;
  }

  .action-button {
    font-family: "Kaushan Script", cursive;
    font-weight: 600;
  }
</style>

<style lang="less">
  @import "../../../style/theme.less";

  .ant-progress .ant-progress-inner {
    background-color: @slider-rail-background-color;
  }
</style>

<template>
  <a-spin :spinning="loading" size="large">
    <a-icon slot="indicator" type="loading" style="font-size: 48px" spin />
    <div class="spin-content">
      <p class="small" v-if="showInstructions">Select below the circles which answer the questions as accurately as possible.</p>
      <div class="spacer-lg" />
      <!-- <h1>I...</h1> -->

      <transition-group tag="div" name="fade-in-out">
        <div
          v-for="(q, index) in displayedQuestions"
          :key="q.id"
        >
          <question
            :data-index="index"
            :questionText="q.questionText"
            @change="answer => answers[q.id] = answer"
            :defaultValue="answers[q.id] || 3"
            :showTooltip="false"
          />
          <a-divider v-if="index < displayedQuestions.length - 1" class="divider" />
          <div class="spacer-lg" v-else />
        </div>
      </transition-group>

      <div class="spacer-lg" />

      <a-button
        class="action-button"
        size="large"
        shape="round"
        type="primary"
        @click="nextQuestions"
        :loading="loading"
        :disabled="loading"
      >
        {{ lastQuestions ? 'Submit' : 'Continue' }}
      </a-button>

      <div class="spacer-lg" />

      <a-progress :percent="progress" />
    </div>
  </a-spin>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';

import { getErrorMessage } from '../../../lib/utils';

import question from './question/';

export default {
  name: 'user.questions',

  data: () => ({
    loading: false,
    progress: 0,
    displayedQuestions: [],
    lastQuestions: false,
    showInstructions: true,
  }),

  components: {
    question,
  },

  mounted() {
    if (!this.licenseKey) {
      return this.returnHome();
    }

    if (this.submission.answers && this.submission.answers.length) {
      this.answers = this.submission.answers.reduce((acc, { questionId, value, }) => {
        acc[questionId] = value;
        return acc;
      }, {});
    }

    this.loading = true;

    return this.getQuestions().then(() => {
      this.loading = false;
      return this.nextQuestions({ saveProgress: false, });
    });
  },

  computed: mapState('user', ['licenseKey', 'submission', 'answers', 'questions',]),

  methods: {
    ...mapActions('user', ['getQuestions', 'submitAnswers', 'completeSubmission',]),
    ...mapMutations('user', ['setAnswer',]),

    async nextQuestions({ saveProgress = true, }) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.displayedQuestions = [];
      this.showInstructions = !saveProgress;

      await new Promise(resolve => setTimeout(resolve, 500));

      for (let i = 0; i < 10; i++) {
        const availableQuestions = this.getAvailableQuestions();

        this.lastQuestions = availableQuestions.length <= 10;

        if (availableQuestions.length) {
          this.displayedQuestions.push(availableQuestions.pop());
        }
      }

      this.progress = (Object.keys(this.answers).length * 100) / this.questions.length;

      if (!saveProgress || Object.keys(this.answers).length === 0) {
        this.loading = false;
        return;
      }

      return this.submitAnswers()
        .then(() => {
          if (this.getUnansweredQuestions().length === 0) {
            return this.completeSubmission()
              .then(() => this.$router.replace({ name:'user.report', }));
          }
        })
        .finally(() => {
          this.loading = false;
          document.getElementsByClassName('content')[0].scrollTop = 0;
          window.scrollTo(0, 0);
        });
    },

    getAvailableQuestions() {
      return this.questions.filter(({ id, }) => {
        const alreadyAnswered = Object.keys(this.answers).includes(id);
        const alreadyDisplayed = this.displayedQuestions.map(({ id, }) => id).includes(id);

        return !alreadyAnswered && !alreadyDisplayed;
      });
    },

    getUnansweredQuestions() {
      return this.questions.filter(({ id, }) => !Object.keys(this.answers).includes(id));
    },

    returnHome() {
      return this.$router.replace({ name: 'user.landing', });
    },

    error(e) {
      return this.$error({
        title: 'Something went wrong',
        content: (
          <div>
            <p>{ getErrorMessage(e) }</p>
            <p>If this keeps happening, please reach out to us <a href="https://goddessgift.com/contact/" target="_blank">here</a></p>
          </div>
        ),
        onOk: this.returnHome,
      });
    },
  },
};
</script>
